import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { useSiteActivationContext } from '../../hooks/site-activation-context';

export const HelperText = () => {
	const { formatMessage } = useIntl();

	const { isWorkspaceProduct, autoActivationFailed } = useSiteActivationContext();

	// spark-defer-site-name-v2 (TWCG-2407): once auto-activation has failed and
	// fallen back to this form, a real error is already shown for the site
	// name — the generic "this is just a suggestion" hint is redundant next to
	// it. Control and every other cohort never set this flag, so they're
	// unaffected.
	if (autoActivationFailed) {
		return null;
	}

	const text = isWorkspaceProduct
		? formatMessage({
				id: 'siteActivation.nameSite.inputWorkspaceNameHelperText',
				defaultMessage:
					'This workspace name is just a suggestion. Feel free to change to something your team will recognize.',
			})
		: formatMessage({
				id: 'siteActivation.nameSite.inputSiteNameHelperText',
				defaultMessage:
					'This site name is just a suggestion. Feel free to change to something your team will recognize.',
			});

	return (
		<p id="site-name-helper" css={helperTextCss}>
			{text}
		</p>
	);
};

const helperTextCss = css({
	color: 'inherit',
	fontSize: '0.75rem',
	lineHeight: 1.5,
	margin: '0.5rem 0 0',
});
